import { CypressAttribute } from '@/test-utils/constants/CypressAttribute';

export class TimeEntryCypressAttribute extends CypressAttribute {
  static buttons = {
    SAVE_TIME_ENTRY: 'TimeEntryCypressAttribute:buttons:SAVE_TIME_ENTRY',
    DELETE_TIME_ENTRY: 'TimeEntryCypressAttribute:buttons:DELETE_TIME_ENTRY',
    EDIT_TIME_ENTRY: 'TimeEntryCypressAttribute:buttons:EDIT_TIME_ENTRY',
    ADD_TIME_ENTRY_POPOVER: 'TimeEntryCypressAttribute:buttons:ADD_TIME_ENTRY_POPOVER',
    PREVIOUS_WEEK: 'TimeEntryCypressAttribute:buttons:PREVIOUS_WEEK',
    CURRENT_WEEK: 'TimeEntryCypressAttribute:buttons:CURRENT_WEEK',
    NEXT_WEEK: 'TimeEntryCypressAttribute:buttons:NEXT_WEEK',
    DATE_TRIGGER: 'TimeEntryCypressAttribute:buttons:DATE_TRIGGER'
  };

  static inputs = {
    DATE: 'TimeEntryCypressAttribute:inputs:DATE',
    DURATION: 'TimeEntryCypressAttribute:inputs:DURATION',
    DESCRIPTION: 'TimeEntryCypressAttribute:inputs:DESCRIPTION',
    USED_AI: 'TimeEntryCypressAttribute:inputs:USED_AI'
  };

  static views = {
    TIME_ENTRIES_TABLE: 'TimeEntryCypressAttribute:views:TIME_ENTRIES_TABLE',
    TIME_ENTRY_ACTIONS_DIV: 'TimeEntryCypressAttribute:views:TIME_ENTRY_ACTIONS_DIV',
    USER_COLLAPSE: 'TimeEntryCypressAttribute:views:USER_COLLAPSE',
    USER_COLLAPSE_NAME: 'TimeEntryCypressAttribute:views:USER_COLLAPSE_NAME',
    TIME_ENTRY_ROW: 'TimeEntryCypressAttribute:views:TIME_ENTRY_ROW',
    TIME_ENTRY_ROW_DATE: 'TimeEntryCypressAttribute:views:TIME_ENTRY_ROW_DATE',
    TIME_ENTRY_ROW_DURATION: 'TimeEntryCypressAttribute:views:TIME_ENTRY_ROW_DURATION',
    TIME_ENTRY_ROW_STATUS: 'TimeEntryCypressAttribute:views:TIME_ENTRY_ROW_STATUS',
    TIME_ENTRY_ROW_USED_AI: 'TimeEntryCypressAttribute:views:TIME_ENTRY_ROW_USED_AI',
    ADD_TIME_ENTRY_FORM: 'TimeEntryCypressAttribute:views:ADD_TIME_ENTRY_FORM',
    DAY_COLUMN_HEADER: 'TimeEntryCypressAttribute:views:DAY_COLUMN_HEADER'
  };
}
